export default "__VITE_ASSET__CSCpqbg9__"